var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 12.5,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h24v24H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87d5fa",
    fillRule: "evenodd",
    d: "M2.938 0a.69.69 0 0 0-.488.19c-.02.02-.889.82-1.396 1.351-1.189 1.236-1.37 2.75-.555 4.633.62 1.434 1.843 3.051 3.738 4.946 2.876 2.875 5.104 4.214 7.013 4.214.958 0 1.824-.364 2.572-1.083a29.414 29.414 0 0 0 1.337-1.335.694.694 0 0 0 .01-.986l-2.297-2.298a.694.694 0 0 0-.49-.19.69.69 0 0 0-.487.19l-1.022 1.021a1.48 1.48 0 0 1-1.042.42 1.48 1.48 0 0 1-1.044-.42L4.703 6.57a1.465 1.465 0 0 1-.431-1.042c0-.395.153-.765.43-1.043l1.022-1.02a.686.686 0 0 0 .202-.489.684.684 0 0 0-.202-.487L3.427.19A.69.69 0 0 0 2.938 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8e7e4a472a0e521f02ca4baf602ed9a9.svg";
export { ForwardRef as ReactComponent };